export default __webpack_public_path__ + "static/media/OpenNew.989d48b5.svg";